'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UIList from 'UIComponents/list/UIList';
import Small from 'UIComponents/elements/Small';
import ScheduleSummary from './ScheduleSummary';

const FBAdSetSummary = ({
  entity,
  adAccount: {
    currencyCode
  }
}) => {
  const {
    budget,
    schedule
  } = entity;
  return /*#__PURE__*/_jsxs(UIList, {
    childClassName: "m-y-1",
    firstChildClassName: "m-bottom-1",
    children: [/*#__PURE__*/_jsx(ScheduleSummary, {
      schedule: schedule
    }), budget && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `campaigns.summary.budget.${budget.type}`,
          options: {
            budget: I18n.formatCurrency(budget.value, {
              currencyCode
            })
          }
        })
      })
    })]
  });
};

export default FBAdSetSummary;